module.exports = __webpack_public_path__ + "static/media/bagActive.d50b83eb.png";